module.exports = __webpack_public_path__ + "img/8.abb62f9a.png";